export default "__VITE_ASSET__BIF2QyJr__"